import getMessagesForNamespaces from "@lib/i18n/getMessagesForNamespaces";
import queryString from "query-string";
import { defaultLocale } from "@lib/i18n/config";
import Auth from "@components/views/TunnelSteps/Steps/Auth";
import { checkUserToken } from "@utils/call-api/auths-call";

function TunnelStepAuth() {
  return <Auth />;
}

export async function getServerSideProps({ query, req, params: { locale } }) {
  const jwt = req.cookies["jwt-token"];

  const isUserLoggedIn = await checkUserToken(jwt);

  if (isUserLoggedIn) {
    const destinationLocale = locale !== defaultLocale ? `/${locale}` : "";
    const queryClone = { ...query };
    delete queryClone.locale;
    const queryStringified = queryString.stringify(queryClone);
    const destination = `${destinationLocale}/je-commence/ready-to-subscribe${queryStringified ? `?${queryStringified}` : ""}`;

    return {
      redirect: {
        destination,
        permanent: false,
      },
    };
  }

  return {
    props: {
      headerBehaviors: { noNavbar: true, noFooter: true },
      ...(await getMessagesForNamespaces(locale, ["common", "tunnel_steps"])),
    },
  };
}

TunnelStepAuth.requireAuth = false;

export default TunnelStepAuth;
